import { HttpClient } from "../../../core/request";

export const fetchContent = () => HttpClient().get("/contents/dd_terms_and_condition_page");



// WEBPACK FOOTER //
// ./src/routes/TermsAndConditions/modules/t&c.js